import ValoresRepository from "@/services/ValoresRepository";
import Vue from "vue";

let listaIcono = {
  "Preparar terreno": "snowplow",
  "Fitosanitario Quimicos": "flask",
  "Fitosanitario Maquinarias": "tractor",
  "Trabajo Mecanico": "cogs",
  "Sembrar o plantar": "seedling",
  Abono: "fill-drip",
  Cosecha: "truck-loading",
  "Tratamiento semilla": "lemon",
};

export default {
  namespaced: true,
  state: {
    listaRubro: [],
  },
  getters: {
    getRubro: (state) => (idRubro) => {
      return state.listaRubro.find((rubro) => rubro.idRubro === idRubro);
    },

    getRubroByIdTipoTrabajo: (state) => (idTipoTrabajo) => {
      return state.listaRubro.find((rubro) =>
        rubro.tipoTrabajoList.find(
          (tipo) => tipo.idTipoTrabajo === idTipoTrabajo
        )
      );
    },

    getRubroBySlug: (state) => (rubroSlug) => {
      return (
        state.listaRubro.find((rubro) => rubro.rubroSlug === rubroSlug) || {}
      );
    },
  },
  mutations: {
    setListaRubro(state, listaRubro) {
      state.listaRubro = listaRubro.map((rubro) => {
        rubro.icono = listaIcono[rubro.nombre] || "leaf";
        rubro.rubroSlug = Vue.filter("fhSlug")(rubro.nombre);
        return rubro;
      });
    },
  },
  actions: {
    async fetchListaRubro({ state, commit }) {
      if (state.listaRubro && state.listaRubro.length > 0) {
        return;
      }

      let listaRubro = await ValoresRepository.listaRubro();
      commit("setListaRubro", listaRubro);
    },
  },
};
